<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>

<div class="container d-flex justify-content-center py-5">
  
    <form  *ngIf="!data.sms_error"  (ngSubmit)="submitOtp()" class="form-adjust " [formGroup]="mfaForm">
      <div class="form-group">
        <label>
          <div class=" ml-1 " *ngIf="twoFAType == 'Email'">{{ 'home.loginForm.sentVerificationCode' | cxTranslate }} </div>
          <div class=" ml-1 " *ngIf="twoFAType == 'SMS'">{{ 'home.loginForm.sentVerificationCodeSMS' | cxTranslate }} </div>
          <div class=" mb-4 ml-1">{{ 'home.loginForm.digit' | cxTranslate }} </div>
          <div class="strong  mb-1 ml-1">{{ 'home.loginForm.otpCode' | cxTranslate }} </div>
          <input
            type="text"
            class="form-control form-control-lg text-secondary  mt-2"
            formControlName="code" (keypress)="allowNumbersOnly($event)"
            placeholder="{{ 'home.loginForm.enterCode' | cxTranslate }}"
          />
        </label>
        <cx-form-errors [control]="mfaForm.get('code')" prefix="home"></cx-form-errors>
      </div>
      <div class="row">
        <div class="pb-3 col-md-6" *ngIf="clearTimeoutFlag">  
          <a class="small text-secondary text-decoration-underline text-black" (click)="resend(twoFAType)"  [ngClass]="{'anchor-disable' : blockedTimeoutFlag}">
            {{'home.loginForm.resendCode'  | cxTranslate}} {{twoFAType}}
          </a>
        </div>
        <div  class="col-md-6" *ngIf="!clearTimeoutFlag">{{'home.loginForm.resendOtpTimer'| cxTranslate }}{{timeLeft}}</div>
        <div class="col-md-6" *ngIf="blockedTimeoutFlag">{{'home.loginForm.resendOtpBlocked'| cxTranslate }} {{display}}</div> 
  
      </div>
      
      <div class="form-group">
          <button type="submit" class="btn btn-lg btn-block btn-primary rounded-1 mb-3 md-font" [disabled]="isDisabled ||!mfaForm.valid">
            {{ 'home.loginForm.submit' | cxTranslate }}
          </button>
      </div>
      <div class="form-group">
        <div>
          <button class="btn btn-block btn-lg btn-link" type="button" (click)="onCancel()">
            {{ "home.quote.Cancel" | cxTranslate }}
          </button>
          <p class="text-center">
            {{'home.loginForm.TroubleSignIn' | cxTranslate}}
          </p>
        </div>
      </div>
    
      <!-- <div *ngIf="loginData.error && notValidCreds" class="text-danger text-center mt-3 strong ">{{loginData.error}}</div> -->
    </form>
  
<div  *ngIf="data.sms_error=='true'">
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="15%" fill="grey" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
  </svg>
  <div class="text-center" [innerHTML]="data.error">
  </div>
  <button class="btn btn-lg btn-block btn-link rounded-1 md-font" (click)="onCancel()">
    {{'home.forgotPassword.btnToLogin' | cxTranslate }}
   </button>
</div>

</div>
  

<div *ngIf="showMsg" class="text-danger text-center mb-5 strong "> {{ "home.loginForm.invalidCodeProvided" | cxTranslate }}</div>

